import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconApartmentSvg } from "./IconApartmentSvg.mjs";
const IconApartment = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconApartmentSvg, ...iconProps });
};
export {
  IconApartment
};
